import Assets from "../../../../../assets/Assets";
import Barcode from "react-barcode";
import { useCardPrint } from "./useCardPrint";
import QRCode from "react-qr-code";
import { min } from "date-fns";
import { he } from "date-fns/locale";

export const PaperStaticD = ({value}) => {
  
  const { renderText } = useCardPrint();

  const arrayItems = value?.data?.graded_values;
  // const topArray = arrayItems?.slice(0,2);
  // const middleArray = arrayItems?.slice(2);

  // const topArray = arrayItems?.filter(item=>item?.slug !== "comments" && item?.slug !== "conclusion");
  // const bottomArray = arrayItems?.filter(item=>item?.slug === "comments" || item?.slug === "conclusion");


  // const topArray = arrayItems?.slice(0,6)?.filter(item=>
  //   item?.slug !== "comments" && 
  //   item?.slug !== "conclusion");
  // const middleArray = arrayItems?.slice(6)?.filter(item=>
  //   item?.slug !== "comments" && 
  //   item?.slug !== "conclusion");
  // const bottomArray = arrayItems?.filter(item=>
  //   item?.slug === "comments" ||  
  //   item?.slug === "conclusion");

    const topArray = arrayItems?.filter((item) => parseInt(item?.section) === 1);
  const middleArray = arrayItems?.filter(
    (item) => parseInt(item?.section) === 2
  );

    const middleArray2 = arrayItems?.filter(
    (item) => parseInt(item?.section) === 4
  );
  const bottomArray = arrayItems?.filter(
    (item) => parseInt(item?.section) === 3
  );


  //to change the length of key
  const maxKeyLength = arrayItems?.reduce((max, str) => Math.max(max, str?.text?.length), 0);
  const bg_img = value?.background_image;
  const outerWrapperStyle = {
    ...styles.outer_wrapper,
    backgroundImage: bg_img ? `url(${bg_img})` : 'none',
  };

  return (
    <>
      <div style={outerWrapperStyle}>
        <div style={styles.header_report_wrap}>
          <div style={styles.header_wrap}>
            <img style={styles.header_img} src={value?.front_top_image} alt="Header"/>
              {parseInt(value?.qr_and_image_format) ===  2  && value?.qr   && (
                <span style={styles.qr_wrap}>
                  <QRCode
                    value={value?.qr}
                    width={70}
                    height={70}
                    style={styles.qr_code}
                  />
                </span>
              )}
          </div>
          <div style={styles.lab_report_wrap}>
            <div style={styles.barcode_title}>
              <div style={styles.col}>
                <h4 style={styles.report_title}>LAB REPORT</h4>
              </div>
              {/* <div style={styles.col}> */}
              <div style={styles.barcode_wrap}>
                  {value?.certificate_number && (
                        <Barcode
                        value={value?.certificate_number}
                        height={22}
                        width={1.5}
                        displayValue={false}
                        margin={0}
                        />
                    )}
              </div>
              {/* </div> */}
            </div>
            <div style={styles.certificate_num}>
              <div style={styles.row}>
                  <div style={styles.col_35}>
                      <div style={styles.row}>
                          <span style={styles.certi_key}>
                          {value?.bold === 1 ? (
                            <b style={{fontWeight : "600"}}>SUMMARY NO</b>
                          ) : "SUMMARY NO"}
                          </span>
                          <span style={styles.certi_separate}>:</span>
                          <span style={styles.certi_value}>
                          {value?.bold === 1 ? (
                            <b style={{fontWeight : "600"}}>{value?.certificate_number}</b>
                          ): value?.certificate_number}
                          </span>
                      </div>  
                  </div>
                  <div style={styles.col_65}>
                      <strong style={styles.certi_info}>THIS Document Contains Valuable Data so keep in a secure Area</strong>
                  </div>
              </div>
            </div>
          </div>
        </div>
        <div style={styles.body}>
          <div style={styles.top_wrap}>
            <div style={styles.row}>
              <div style={styles.content_wrap}>
                {topArray?.map((item,index)=>(
                <div style={styles.row} key={index}>
                  <p style={styles.key}>
                  {item?.bold === 1  ?(
                      <b style={{fontWeight : "600"}}>{renderText(item?.text, item?.key_font_case)}</b>
                    ):renderText(item?.text, item?.key_font_case)}
                  </p>
                  <p style={styles.separate}>:</p>
                 <p style={{ ...styles.value, ...styles.padR_40 }}>
                  {item?.bold === 1 ? (
                    <b style={{fontWeight : "600"}}>{renderText(item?.value, item?.value_font_case)}</b>
                  ) : renderText(item?.value, item?.value_font_case)}
                  </p>
                </div>
                ))} 
              </div>
              {/* <div style={styles.img_wrap}>
                  <figure style={styles.logo_wrap}>
                    <img  style={styles.logo_img} src={value?.shop_logo} alt="shop logo" />
                  </figure>
              </div> */}
            </div>
          </div>
          <div style={styles.middle_wrap}>
            <div style={styles.content_wrap}>
            {middleArray?.map((item, index)=>(
              <div style={styles.row} key={index}>
                <p style={styles.key}>
                  {item?.bold === 1  ?(
                    <b style={{fontWeight : "600"}}>{renderText(item?.text, item?.key_font_case)}</b>
                  ):renderText(item?.text, item?.key_font_case)}
                </p>
                <p style={styles.separate}>:</p>
                <p style={styles.value}>
                  {item?.bold === 1 ? (
                    <b style={{fontWeight : "600"}}>{renderText(item?.value, item?.value_font_case)}</b>
                  ) : renderText(item?.value, item?.value_font_case)}
                </p>
              </div>
             
            ))}
             
            </div>
          {value?.image && 
            <div style={styles.img_wrap}>
                <img style={styles.main_img} src={value?.image} alt="Card images" />
            </div>
          }
          </div>
          <div style={styles.middle_bottom_wrap}>
            <div style={styles.content_wrap}>
            {middleArray2?.map((item, index)=>(
              <div style={styles.row} key={index}>
                <p style={styles.key}>
                  {item?.bold === 1  ?(
                    <b style={{fontWeight : "600"}}>{renderText(item?.text, item?.key_font_case)}</b>
                  ):renderText(item?.text, item?.key_font_case)}
                </p>
                <p style={styles.separate}>:</p>
                <p style={{ ...styles.value, ...styles.padR_40 }}>
                  {item?.bold === 1 ? (
                    <b style={{fontWeight : "600"}}>{renderText(item?.value, item?.value_font_case)}</b>
                  ) : renderText(item?.value, item?.value_font_case)}
                </p>
              </div>
             
            ))}
             
            </div>
          </div>
          <div style={styles.bottom_wrap} className="bottomsec">
          {bottomArray?.map((item,index)=>(
            <div style={styles.row} key={index}>
              <p style={styles.key}>
              {item?.bold === 1  ?(
                    <b style={{fontWeight : "600"}}>{renderText(item?.text, item?.key_font_case)}</b>
                  ):renderText(item?.text, item?.key_font_case)}
              </p>
              <p style={styles.separate}>:</p>
              <p style={styles.value}>
              {item?.bold === 1 ? (
                    <b style={{fontWeight : "600"}}>{renderText(item?.value, item?.value_font_case)}</b>
                  ) : renderText(item?.value, item?.value_font_case)}</p>  
            </div> 
          ))}  
          </div>   
          {/* <div style={styles.bottom_wrap} className="bottomsec">
          {bottomArray?.map((item,index)=>(
            <div style={styles.row} key={index}>
              <p style={styles.stone_key}>
              {item?.bold === 1  ?(
                    <b style={{fontWeight : "600"}}>{renderText(item?.text, item?.key_font_case)}</b>
                  ):renderText(item?.text, item?.key_font_case)}
              </p>
              <p style={styles.stone_separate}>:</p>
              <p style={styles.stone_value}>
              {item?.bold === 1 ? (
                    <b style={{fontWeight : "600"}}>{renderText(item?.value, item?.value_font_case)}</b>
                  ) : renderText(item?.value, item?.value_font_case)}</p>  
            </div> 
          ))}  
          </div>       */}
        </div>
        <div style={styles.footer_wrap}>
            <img style={styles.footer_img} src={value?.front_foot_image} alt="Card footer"/>
        </div>
        
      </div>
    </>
  );
};

const styles = {
  outer_wrapper:  {
    position:'relative',
    width  :'100%',
    minWidth : 760,
    maxWidth : 760,
    fontSize: 14,
    // height : 207,
    // maxHeight : 207,
    // minHeight : 207,
    // border  : '1px solid #f7f7f7',
    color : "#000000",
    backgroundColor: "#ffffff",
    overflow : "hidden",
    fontFamily: "'Graphik',san-serif",
    backgroundSize:'cover',
    boxSizing:'border-box',
    paddingTop:10,
  },
  header_report_wrap : {
    width : '100%',
    height : 200,
    boxSizing:'border-box',
    backgroundColor:'lightred',
  },
  header_wrap : {
    display : "flex",
    alignItems : "center",
    maxWidth : '100%',
    minWidth : '100%',
    // height : 47.24,
    // height : '1.2cm'
    width : '100%',
    position : 'relative',
    boxSizing:'border-box',
  },
  header_img :{
     maxWidth : '100%',
    width : '100%',
    // maxHeight : 47.24,
    // height : 47.24,
  },
  qr_wrap : {
    width : 70, 
    height : 70, 
    display : "inline-block", 
    position : "absolute",  
    top : 20,
    right : 40,
  },
  qr_code : {
    width: 70,
    height: 70,
  },
  barcode_title:{
    position:'relative',
    display:'flex',
    width:'100%',
    justifyContent: 'center',
    alignItems: 'center',
    margin:'10px 0 15px',
  },
  barcode_wrap:{
    textAlign:'left',
    width:'100%',
    position:'absolute',
    left:0,
    right:0,
    top:'56%',
    padding:'0 40px',
    transform:'translateY(-50%)',
  },
  report_title:{
    textAlign:'center',
    flex:'1',
    width:'100%',
  },
  footer_wrap : {
    // height : 14,
    // height : '0.8cm'
    // maxHeight:365,
    // height:365,
    maxHeight:315,
    height:315,
    width : '100%',
    display : "flex",
    justifyContent:'center',
    alignItems:'center',
    position:'relative',
    paddingBottom:10,
    borderBottom: '1px solid #ccc',
    boxSizing:'border-box',
    // bottom:20,
    // left:20,
    //right:20
  },
  footer_img :{
    width : '100%',
    maxHeight:365,
    // maxHeight : 14,
    // height : 14,
  },
  body: {
    // height : 14,1.76,
    // maxHeight : 14,1.76,
    padding : '1px 0',
    boxSizing:'border-box',
    width : '100%',
    minHeight: 595,
    maxHeight: 595,
    height:595,
    display:'flex',
    flexDirection:'column',
    justifyContent:'space-between',
    boxSizing:'border-box',
    position:'relative',
    overflow:'hidden',
    boxSizing:'border-box',
    // backgroundColor:'blue'
  },
 
  row :{
    display : 'flex',
    padding : '0.8px 0px',
    fontSize: 14,
    boxSizing:'border-box',
    width:'100%',
  },
  col:{
     boxSizing:'border-box',
    // width:'50%',
    // padding : '0px 15px'
  },
  col_40:{
    width:'40%',
    boxSizing:'border-box',
    
  },
  col_60:{
    width:'60%',
    boxSizing:'border-box',
  },
   col_35:{
    width:'32%',
    boxSizing:'border-box',
    
  },
  col_65:{
    width:'68%',
    boxSizing:'border-box',
    
  },
  certi_key: {
    textTransform: 'uppercase',
    flex : "1",
    verticalAlign: "bottom",
    fontWeight: 400,
    lineHeight: "1.1",
    marginBottom:0,
    fontSize : 14,
    letterSpacing:'0.5px',
    whiteSpace:'nowrap', 
  },
  certi_value: {
    textTransform: 'uppercase',
    flex : "1",
    verticalAlign: "bottom",
    fontWeight: 400,
    lineHeight: "1.1",
    marginBottom:0,
    fontSize : 14,
    letterSpacing:'0.5px',
    whiteSpace:'nowrap',
  },
  certi_separate: {
    width: 10,
    paddingRight: 4,
    paddingLeft: 4,
    fontWeight : 400,
    fontSize:  14,
    lineHeight: "1.1",
    marginBottom:0,
  },
  certi_info: {
    textTransform: 'uppercase',
    fontWeight:600,
    fontSize:11,
    display:'block',
    textAlign:'right',
    paddingLeft:10,

  },
  key: {
    width:165,
    fontSize: 14,
    fontWeight: 400,
    lineHeight: "1.2",
    marginBottom:5,
    paddingRight:10,
  },
  value: {
    flex : "1",
    verticalAlign: "top",
    fontWeight: 400,
    lineHeight: "1.2",
    marginBottom:8,
    fontSize : 14,
    paddingLeft:15
    
  },
  separate: {
    width: 20,
    paddingRight: 4,
    paddingLeft: 4,
    fontWeight : 400,
    fontSize:  14,
    lineHeight: "1.1",
    textAlign:'center',
    marginBottom:0,
  },
  content_wrap :{
    flex : "1",
    paddingLeft:40,
    // paddingRight:40,
    // backgroundColor:'red',
    boxSizing:'border-box',
  },
  logo_wrap: {
    // maxWidth:350,
    width:'100%',
    marginLeft:'auto',
    marginBottom:30
  },
  logo_img :{
      maxHeight:100, 
      maxWidth:'100%',
      width:'100%',
      display:'block',
      marginLeft:'auto'
   },
img_wrap: {
  width: 264.6,
  height: 264.6,
  backgroundColor: 'black',
  position: 'relative',
  marginRight:38,
},

main_img: {
  maxWidth: 264,
  maxHeight: 264,
  objectFit: 'contain',
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
},
  lab_report_wrap:{
    position:'relative',
    // marginBottom:20,
    
  },
  report_title: {
    fontSize: 15,
    fontWeight: 400,
    lineHeight: "1",
    margin:0,
    textAlign:'left'
  },
  certificate_num: {
    backgroundColor: '#18a3f3',
    color:'#fff',
    fontWeight: 400,
    padding: '10px 40px',
    width:'100%',
    boxSizing:'border-box',
  },
  padR_40 : {
    paddingRight:40,
  },
  //  top_wrap: {
  //  minHeight: 100,
  // },
  top_wrap :{
    minHeight : 166.3,
    boxSizing:'border-box',
    // backgroundColor:'lightyellow',
  },
  middle_wrap: {
    display : 'flex',
    // alignItems : 'center',
    padding : '1px 0',
    marginTop:19,
    //marginBottom:19,
    // backgroundColor:'lightblue',
    //minHeight: 340,
    
  },
  middle_bottom_wrap:{
     display : 'flex',
     padding : '1px 0',
     boxSizing:'border-box',
    // backgroundColor:'lightcyan',
     marginBottom:19,
  },
  bottom_wrap:{
    // backgroundColor:'lightgreen',
    padding:'0 40px 0',
  } 
  
};
